import { Plugin } from '@nuxt/types';
import { v4 } from 'uuid';

type AnalyticsEventType = 'click' | 'pageView'; // <CHECK SPREADSHEET FOR MORE TYPES>

interface MzAnalyticsPlugin {
  $mzAnalyticsApi: ({
    event,
    name,
    productArea,
    module,
    entityType,
    entityId,
  }: {
    event: AnalyticsEventType;
    name?: string;
    productArea?: string;
    module?: string;
    entityType?: string;
    entityId?: number | string;
  }) => Promise<void>;
}

declare module '@nuxt/types' {
  interface Context extends MzAnalyticsPlugin {}
}
const mzAnalyticsPlugin: Plugin = ({ $config, app, store }, inject) => {
  if (process.browser) {
    const script = document.createElement('script');
    console.log('tarkovskyBundleUrl: ' + $config.tarkovskyBundleUrl);
    script.src = $config.tarkovskyBundleUrl;
    script.setAttribute('product', 'tes.teachstarter');
    script.setAttribute('page-view-event', 'custom');
    script.defer = true;
    document.body.appendChild(script);
    //
    const ulClick = document.createElement('ul');
    ulClick.id = 'hiddenClickUlId';
    ulClick.className = 'footer__link-list';
    const liClick = document.createElement('li');
    liClick.id = 'hiddenClickLiId';
    const nuxtLinkClick = document.createElement('nuxt-link');
    nuxtLinkClick.id = 'hiddenClickNuxtLinkId';
    nuxtLinkClick.setAttribute('data-tracking-event', 'click');
    nuxtLinkClick.setAttribute('data-name', 'default');
    nuxtLinkClick.setAttribute('data-entity-id', '');
    nuxtLinkClick.setAttribute('data-entity-type', '');
    nuxtLinkClick.setAttribute('data-product-area', 'default');
    nuxtLinkClick.setAttribute('data-referrer', '');
    nuxtLinkClick.setAttribute('data-session-id', '');
    nuxtLinkClick.setAttribute('data-tuid', '');
    nuxtLinkClick.setAttribute('data-uid', '');
    nuxtLinkClick.setAttribute('data-module', 'teachstarter');
    nuxtLinkClick.setAttribute('display', 'none');
    nuxtLinkClick.className = 'button';
    liClick.appendChild(nuxtLinkClick);
    ulClick.appendChild(liClick);
    document.body.appendChild(ulClick);
  }
  inject(
    'mzAnalyticsApi',
    ({
      event,
      name,
      productArea,
      module,
      entityType,
      entityId,
    }: {
      event: AnalyticsEventType;
      name?: string;
      productArea?: string;
      module?: string;
      entityType?: string;
      entityId?: number | string;
    }) => {
      switch (entityType) {
        case 'teaching-resource':
        case 'teaching_resource':
          entityType = 'resource';
          break;
        case 'unit-plan':
        case 'unit_plan':
          entityType = 'unit';
          break;
        case 'lesson-plan':
        case 'lesson_plan':
          entityType = 'lesson';
          break;
        case 'resource-pack':
        case 'resource_pack':
          entityType = 'pack';
          break;
      }
      switch (productArea) {
        case 'Hub':
          productArea = 'hub';
          break;
        case 'learning area/subject':
          productArea = 'learning_areas_subjects';
          break;
        case 'lesson-plan':
        case 'lesson_plan':
          productArea = 'lesson_plans';
          break;
        case 'pack':
          productArea = 'packs';
          break;
        case 'Profile':
          productArea = 'profile';
          break;
        case 'teaching-resource-collection':
          productArea = 'teaching_resource_collection';
          break;
        case 'unit plans':
        case 'unit_plan':
          productArea = 'unit_plans';
          break;
        case 'widget':
          productArea = 'widgets';
          break;
      }

      switch (name) {
        case 'lesson_plan.download.upgrade_to_plus':
        case 'lesson_plan.download.signup_to_plus':
        case 'lesson_plan.download.signup_to_free':
          productArea = 'lesson_plans';
          break;
        case 'resource_card.download':
          productArea = 'resources';
          break;
        case 'video.share':
          productArea = 'resources';
          entityType = 'video';
          break;
        case 'change_location.update_location':
          productArea = '';
          break;
      }

      const referrer = store.state.previousUrl
        ? window.location.origin + store.state.previousUrl
        : document.referrer; // Previous page
      let sessionId = sessionStorage.getItem('sessionId');
      if (!sessionId) {
        sessionId = v4();
        sessionStorage.setItem('sessionId', sessionId);
      }
      const user = app.$auth.user; // Access user directly from app.$auth
      if (event === 'click') {
        const nuxtLink = document.getElementById('hiddenClickNuxtLinkId') as HTMLElement;
        nuxtLink.setAttribute('data-tracking-event', event);
        nuxtLink.setAttribute('data-name', name || 'default');
        nuxtLink.setAttribute('data-entity-id', entityId?.toString() || '');
        nuxtLink.setAttribute('data-entity-type', entityType || '');
        nuxtLink.setAttribute('data-product-area', productArea || '');
        nuxtLink.setAttribute('data-referrer', referrer);
        nuxtLink.setAttribute('data-session-id', sessionId || '');
        nuxtLink.setAttribute('data-tuid', user?.uuid || '');
        nuxtLink.setAttribute('data-uid', user?.id.toString() || '');
        nuxtLink.setAttribute('data-module', 'teachstarter');
        nuxtLink.click();
        console.log('Click event dispatched in plugin:', {
          name,
          entityId,
          entityType,
          productArea,
          referrer,
          sessionId,
          tuId: user?.uuid || '',
          uId: user?.id || '',
        });
      } else if (event === 'pageView') {
        const customEvent = new CustomEvent('prexitPageViewEvent', {
          bubbles: true, // Ensure it bubbles up to document
          cancelable: true, // Allow it to be canceled if needed
          detail: {
            trackingEvent: event,
            name,
            entityId: entityId || null,
            entityType,
            productArea,
            module,
            referrer,
            sessionId,
            tuId: user?.uuid || '',
            uId: user?.id || '',
          },
        });
        console.log(customEvent.detail);
        document.dispatchEvent(customEvent);
      }
    }
  );
};

export default mzAnalyticsPlugin;
